export function findAutoMyCompareItemId(sourceItems: unknown): string {
  if (!Array.isArray(sourceItems)) return "";
  const matched = sourceItems.find((item) => (
    item !== null
    && typeof item === "object"
    && (item as { has_shop_item_id?: unknown }).has_shop_item_id === true
  )) as { item_id?: unknown } | undefined;
  return matched?.item_id === null || matched?.item_id === undefined
    ? ""
    : String(matched.item_id);
}
